import { useMutation } from '@tanstack/react-query';
import { postVerifyEmail } from '#/api/apiClient';

export type VerificationEmailProps = ReturnType<typeof useVerificationEmail>;

export function useVerificationEmail() {
  const { isSuccess, mutateAsync, error } = useMutation({ mutationFn: () => postVerifyEmail() });
  return {
    sendVerificationEmail: mutateAsync,
    isSuccess,
    error,
  };
}
